import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  GlobalAppEventEnum,
  handleProcess,
  IRydeProcess,
  isProcessCanceledByUser,
  Log,
  RydeProcessTitle,
  RydeUiUnit,
  useProcesses,
} from "@ryde/shared";

import {
  useCompanyScopeContext,
  useDropdownSourceContext,
} from "../../contexts";
import { refreshDropdownItemsForEntity } from "../context-providers/parts";

export const useWatchBulkJourneyClone = ({
  entity,
}: {
  entity: RydeUiUnit;
}) => {
  const { eventEmitter } = useCompanyScopeContext();
  const bulkCloneJourneyProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkJourneyClone,
    entity,
  );

  const { getDropdownItems } = useDropdownSourceContext();
  const bulkCloneJourneysProcess = useRecoilValue(
    activeProcessSF(bulkCloneJourneyProcessKey),
  );
  const { stopProcessPolling } = useProcesses();
  const { t } = useTranslation();

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      if (isProcessCanceledByUser(process)) {
        return;
      }

      Log.infoAndToast(t("journey.bulk.journeysCloned"));

      eventEmitter?.emit(GlobalAppEventEnum.PROCESS_COMPLETED);
      refreshDropdownItemsForEntity({
        entity: "journey",
        getDropdownItems,
      });
    },
    [eventEmitter, getDropdownItems, t],
  );

  useEffect(() => {
    handleProcess({
      entity,
      processTitle: RydeProcessTitle.BulkJourneyClone,
      process: bulkCloneJourneysProcess,
      onComplete,
      translationFunction: t,
      stopProcessPolling,
    });
  }, [bulkCloneJourneysProcess, entity, onComplete, stopProcessPolling, t]);
};
